
export class WarehouseMovement {
  constructor(
    public hash?: string,
    public internalId?: number,
    public code?: string,
    public date?: number,
    public movementType?: string,
    public documentType?: string,
    public document?: string,
    public documentLine?: number,
    public quantity?: number,
    public deliveryNoteLine?: number,
    public deliveryNoteLineCode?: string,
    public deliveryNoteLineDescription?: string,
    public deliveryNoteLineQuantity?: number,
    public deliveryNoteLineCategory?: string,
    public deliveryNoteNumber?: string,
    public deliveryNoteProviderCode?: number,
    public deliveryNoteDate?: number,
    public deliveryNoteRegistrationDate?: number,
    public deliveryNoteProviderName?: string,
    public toolReference?: string,
    public deleted?: boolean,
    public selected?: boolean
  ) { }

  clone() {
    return new WarehouseMovement(
      this.hash,
      this.internalId,
      this.code,
      this.date,
      this.movementType,
      this.documentType,
      this.document,
      this.documentLine,
      this.quantity,
      this.deliveryNoteLine,
      this.deliveryNoteLineCode,
      this.deliveryNoteLineDescription,
      this.deliveryNoteLineQuantity,
      this.deliveryNoteLineCategory,
      this.deliveryNoteNumber,
      this.deliveryNoteProviderCode,
      this.deliveryNoteDate,
      this.deliveryNoteRegistrationDate,
      this.deliveryNoteProviderName,
      this.toolReference,
      this.deleted,
      this.selected
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/warehouse-movement.ts